import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/ticket';

import Select from 'react-select';

import {api, API_URL} from '../../actions/_request';


const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);
const tipos_precios = [
  {label: 'Contado', value: 0},
  {label: 'Credito', value: 1}, 
];



class TicketModal extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {

            formas_pago_codigo:'01',
            metodo_pago_codigo:'PUE',
            uso_cfdi:'P01',
            tipo_precios:0,
            credito:0,

        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        
	}
  handleInputChange(event) {

        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        this.setState({
             [name]: value,
        });
    }

    componentDidMount()
    {
    let ticket=this.props.tic;
    console.log('ticket--->',ticket);
      let self=this;

      api().get('/busqueda_cliente/'+ticket.cliente_id)
      .then(function(response)
      {
        if(response.status === 200)
        {    let cliente= response.data;
           api().get('/formulario_factura')
          .then(function(response)
          {
            if(response.status === 200)
            {
              self.setState({
                formas : response.data.formas,
                metodos : response.data.metodos,
                usos : response.data.usos,
                ticket:ticket,
                formas_pago_codigo:cliente.forma_pago,
                metodo_pago_codigo:cliente.metodo_pago,
                uso_cfdi:cliente.uso_cfdi,  
                plazo_p: parseInt( cliente.credito)===1 ?cliente.plazo_credito:0,  
                cliente:cliente, 
                credito:cliente.credito,          
              });          
            }
          });             
        }
      }); 
     
       

        ////console.log(this.state.ticketVenta)
    }

    

    

    handleSelectChange(select, name) {

        const value = select === null ? null : select.value;

        this.setState({ 
                [name]: value,
        });



    }

    

	handleSubmit(evt)
	{
		evt.preventDefault();
        // console.log('Factura------>',factura)
         let {ticket,metodo_pago_codigo,formas_pago_codigo,uso_cfdi,tipo_precios,plazo_p} = this.state;

       let self = this;
       // self.props.correo(1,[]);
      swal.queue([{
        title: 'Estas seguro?',
        text: "De Timbrar el ticket",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/timbrar_ticket/'+ticket.id+'/'+metodo_pago_codigo+'/'+formas_pago_codigo+'/'+uso_cfdi+'/'+tipo_precios+'/'+plazo_p)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {   
                   if(response.data.estado){

                  // console.log('entor al status 200');
                  // console.log('factura-->',response.data.factura) ;
                  // self.props.timbrar(response.data.factura);

                  // console.log('liga pdf-->  '+API_URL+'/pdf_factura/'+response.data.factura+'/I') ;
                  // window.open(API_URL+'/pdf_factura/'+response.data.factura.id+'/I');
                  self.props.correo(1,response.data.factura,ticket);

                   }else{
                    console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                  
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }]);
		
	}

	render()
	{
       
		
		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>Facturar Ticket</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-md-12"> 
                                    <div className="form-group">
                                      <label className>Clave: {this.props.tic.clave}</label>
                                  </div>
                        </div>
                    </div>

                    <div className="row">
                      <div className="col-3">
                          <div className="form-group">
                              <label>Plazo/P: </label><br/>
                              <input
                                placeholder=""
                                type="number"
                                name="plazo_p"
                                value={this.state.plazo_p}
                                onChange={this.handleInputChange}
                                className="form-control"
                                 disabled= {(parseInt(this.state.credito)===1)? false : true}
                              />
                            </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label className>Tipo:</label>
                            <Select
                              placeholder=""
                              type="text"
                              name="tipo_precios"
                              options={tipos_precios}
                              value={parseInt(this.state.tipo_precios) || 0}
                              onChange={ (select) => { this.handleSelectChange(select, 'tipo_precios') } }
                              disabled= {(parseInt(this.state.credito)===1)? false : true}
                              clearable={false}
                            />
                          </div>
                        </div>
                    </div>





                    <div className="row">
                    <div className="col-md-6"> 
                                <div className="form-group">
                                  <label className>Forma de Pago:</label>
                                  <Select
                                    placeholder=""
                                    type="text"
                                    name="formas_pago_codigo"
                                    options={this.state.formas}
                                    value={this.state.formas_pago_codigo || ""}
                                    onChange={ (select) => { this.handleSelectChange(select, 'formas_pago_codigo',1) } }
                                    clearable={false}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6"> 
                                <div className="form-group">
                                    <label className>Metodo de Pago:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="metodo_pago_codigo"
                                        options={this.state.metodos}
                                        value={this.state.metodo_pago_codigo || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'metodo_pago_codigo',1) } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-md-12"> 
                                <div className="form-group">
                                    <label className>Uso del CFDI:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="uso_cfdi"
                                        options={this.state.usos}
                                        value={this.state.uso_cfdi || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'uso_cfdi',1) } }
                                        clearable={false}

                                    />
                                </div>
                            </div>

                    </div>
                    
                </ModalBody>
                <ModalFooter>
                    {
                    	this.props.ticket.saving ?
                    	<SubmitLoad /> : 
                    	<div>
                    		<Button color="primary" type="submit" >
                    			Facturar
                    		</Button>{' '}
                    		<Button color="secondary" onClick={this.props.toggle}>
		                    	Cancel
		                    </Button>
                    	</div>
                    }
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        ticket : state.ticket,
    }
};

export default connect(mapStateToProps, actions)(TicketModal)


// WEBPACK FOOTER //
// ./src/components/facturarTicket/ModalFactura.js